import TooltipMobileModal from './TooltipMobileModal'

export default TooltipMobileModal